import api from './axios';

// ===== 인증 =====
export const authAPI = {
  login: (username: string, password: string) =>
    api.post('/api/auth/login/', { username, password }),
  register: (data: any) =>
    api.post('/api/auth/register/', data),
  logout: () =>
    api.post('/api/auth/logout/'),
  me: () =>
    api.get('/api/auth/me/'),
};

// ===== 회원 관리 (관리자) =====
export const userAPI = {
  list: () => api.get('/api/auth/users/'),
  updateStatus: (userId: number, status: string) =>
    api.patch(`/api/auth/users/${userId}/status/`, { status }),
  delete: (userId: number) =>
    api.delete(`/api/auth/users/${userId}/`),
};

// ===== 종목/문제 =====
export const questionAPI = {
  // 종목 목록 (일반)
  subjects: (exam_type?: string) =>
    api.get('/api/questions/subjects/', { params: { exam_type } }),

  // 문제 목록
  list: (params: any) =>
    api.get('/api/questions/list/', { params }),

  // 문제파일 목록 (년도/차수 단위)
  questionFiles: (subject_id: number, exam_type?: string) =>
    api.get('/api/questions/files/', { params: { subject_id, exam_type } }),

  // 오답노트
  wrongAnswers: (exam_type: string, is_mock: boolean) =>
    api.get('/api/questions/wrong/', { params: { exam_type, is_mock } }),
  addWrong: (data: any) =>
    api.post('/api/questions/wrong/', data),
  deleteWrong: (data: any) =>
    api.delete('/api/questions/wrong/', { data }),

  // ✅ 모의고사 결과
  saveMockResult: (data: any) =>
    api.post('/api/questions/mock-result/', data),
  myMockResults: (params?: any) =>
    api.get('/api/questions/mock-result/', { params }),
  myStats: () =>
    api.get('/api/questions/my-stats/'),

  // 관리자 - 종목
  adminSubjects: () =>
    api.get('/api/questions/admin/subjects/'),
  createSubject: (data: any) =>
    api.post('/api/questions/admin/subjects/', data),
  updateSubject: (id: number, data: any) =>
    api.put(`/api/questions/admin/subjects/${id}/`, data),
  deleteSubject: (id: number) =>
    api.delete(`/api/questions/admin/subjects/${id}/`),

  // 관리자 - 문제파일 (년도/차수 단위)
  adminQuestionFiles: (subject_id?: number) =>
    api.get('/api/questions/admin/files/', { params: { subject_id } }),
  deleteQuestionFile: (file_id: number) =>
    api.delete(`/api/questions/admin/files/${file_id}/delete/`),

  // 관리자 - 문제 엑셀 업로드
  uploadQuestions: (formData: FormData) =>
    api.post('/api/questions/admin/upload/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
};

// ===== 게시판 =====
export const boardAPI = {
  notices: () => api.get('/api/board/notices/'),
  posts: (type: string, category?: string) =>
    api.get('/api/board/posts/', { params: { type, category } }),
  createPost: (data: any) =>
    api.post('/api/board/posts/', data),
  deletePost: (id: number) =>
    api.delete(`/api/board/posts/${id}/`),
  categories: (board_type?: string) =>
    api.get('/api/board/categories/', { params: { board_type } }),
  categoriesAll: (board_type?: string) =>
    api.get('/api/board/categories/all/', { params: { board_type } }),  // 관리자용 전체(비활성 포함)
  addCategory: (data: { board_type: string; name: string }) =>
    api.post('/api/board/categories/', data),
  updateCategory: (id: number, data: any) =>
    api.patch(`/api/board/categories/${id}/`, data),
  deleteCategory: (id: number) =>
    api.delete(`/api/board/categories/${id}/`),
  suggestions: () => api.get('/api/board/suggestions/'),
  createSuggestion: (data: any) =>
    api.post('/api/board/suggestions/', data),
  replySuggestion: (id: number, data: any) =>
    api.patch(`/api/board/suggestions/${id}/reply/`, data),
  deleteSuggestion: (id: number) =>
    api.delete(`/api/board/suggestions/${id}/`),                    // ✅ 추가
  comments: (question_id: number) =>
    api.get('/api/board/comments/', { params: { question_id } }),
  createComment: (data: any) =>
    api.post('/api/board/comments/', data),
  deleteComment: (id: number) =>
    api.delete(`/api/board/comments/${id}/`),                       // ✅ 추가
  monitor: (type: string, board_type?: string, category?: string) =>
    api.get('/api/board/monitor/', { params: { type, board_type, category } }), // ✅ 추가
  calendar: (year: number, month: number) =>
    api.get('/api/board/calendar/', { params: { year, month } }),
  createEvent: (data: any) =>
    api.post('/api/board/calendar/', data),
  deleteEvent: (id: number) =>
    api.delete(`/api/board/calendar/${id}/`),
};

// ===== 관리자 패널 =====
export const adminAPI = {
  settings: () => api.get('/api/admin-panel/settings/'),
  updateSettings: (data: any) =>
    api.put('/api/admin-panel/settings/update/', data),
  restBoxes: () => api.get('/api/admin-panel/rest-boxes/'),
  updateRestBoxes: (boxes: string[]) =>
    api.post('/api/admin-panel/rest-boxes/update/', { boxes }),
  videoPopups: () => api.get('/api/admin-panel/video-popups/'),
  updateVideoPopup: (exam_type: string, data: any) =>
    api.put(`/api/admin-panel/video-popups/${exam_type}/`, data),
  menus: () => api.get('/api/admin-panel/menus/'),
  updateMenus: (menus: any[]) =>
    api.post('/api/admin-panel/menus/update/', { menus }),
  trialQuestions: (exam_type: string) =>
    api.get('/api/admin-panel/trial/', { params: { exam_type } }),

  // ✅ 해설 PDF 자동 연동
  explanationPdfs: (params?: any) =>
    api.get('/api/admin-panel/explanation-pdfs/', { params }),
  createExplanationPdf: (data: any) =>
    api.post('/api/admin-panel/explanation-pdfs/create/', data),
  updateExplanationPdf: (id: number, data: any) =>
    api.put(`/api/admin-panel/explanation-pdfs/${id}/`, data),
  deleteExplanationPdf: (id: number) =>
    api.delete(`/api/admin-panel/explanation-pdfs/${id}/`),
};
